import firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";
import Config from "../config";

const defaultFirebaseApp = firebase.initializeApp(Config.firebaseConfig);
export const adminDatabase = defaultFirebaseApp.database(Config.adminDatabase);
export default firebase;



// WEBPACK FOOTER //
// ./src/lib/firebase.js